// Webpack Imports
import 'bootstrap';
import 'slick-carousel';
import 'slick-lightbox';
import '../node_modules/owl.carousel2/dist/owl.carousel.js';

$(document).ready(function(){
    $('.gallery').slickLightbox({
        itemSelector: '.gallery__item a'
    });
    var homeslider = jQuery('#homeslider .owl-carousel').owlCarousel({
        items : 1,
        autoplay : true,
        margin: 30,
        autoplayTimeout : 5000,
        autoplayHoverPause : true,
        smartSpeed : 500,
        fluidSpeed : 500,
        autoplaySpeed : 500,
        navSpeed : 500,
        dotsSpeed : 500,
        loop : true,
        nav : true,
        dots: false,
        responsiveRefreshRate : 200,
        slideBy : 1,
        mergeFit : true,
        autoHeight : false,
        mouseDrag : false,
        touchDrag : true,
        navText: ["<img src='/wp-content/themes/sport4fun/assets/img/carousel-left.svg'>","<img src='/wp-content/themes/sport4fun/assets/img/carousel-right.svg'>"]
    });
    homeslider.css('visibility', 'visible');

    stickyheader();
});

$(window).scroll(function(){
    stickyheader();
});

function stickyheader(){
    var currentScroll = $(window).scrollTop();
    if(currentScroll > 0){
        $('#header').addClass('header-scroll');
    } else {
        $('#header').removeClass('header-scroll');
    }
    $('body').css('padding-top', $('#header').outerHeight());
}

const top_btn = document.getElementById('back-to-top');

top_btn.addEventListener('click', () => window.scrollTo({
    top: 100,
    behavior: 'smooth',
}));

$('.wpcf7-acceptance input').on('change', function(){
    var checked = $(this).is(':checked');
    if(checked){
        $(this).parent().addClass('checked');
    } else {
        $(this).parent().removeClass('checked');
    }
});

$('.posts-filters li').click(function(){
    $('.posts-filters li').removeClass('active');
    //$('.project').fadeIn();
    $(this).addClass('active');
    var cat = parseInt($(this).attr('data-category'));
    if(cat > -1){
        $('.post-thumb').each(function(){
            if(parseInt($(this).attr('data-category')) != cat){
                $(this).fadeOut();
            } else {
                $(this).fadeIn();
            }
        });
    } else {
        $('.post-thumb').fadeIn();
    }
});